import { useCallback } from "react";
import type { EventKind, Event, PageInfo } from "../../../api";
import { store } from "../../../store";
import { useFetchAction, type UseFetchActionReturn } from "../utils";
import { defaultPageSize } from "../../../utils/constants";

export const useFetchEvents = (
    eventKinds?: EventKind[],
    search?: string,
    page?: number,
): UseFetchActionReturn<Event[] | undefined> => {
    const fetchEvents: () => Promise<Event[] | undefined> = useCallback(() => {
        return store.eventsApi.eventsListEvents({
            search,
            eventKinds,
            page,
            pageSize: defaultPageSize,
        });
    }, [eventKinds, search, page]);
    return useFetchAction(fetchEvents);
};

export const useFetchEventsMetaData = (
    eventKinds: EventKind[],
    search?: string,
): UseFetchActionReturn<PageInfo | undefined> => {
    const fetchEventsMetaData: () => Promise<PageInfo | undefined> = useCallback(() => {
        return store.eventsApi.eventsListEventsMetadata({
            search,
            eventKinds,
            pageSize: defaultPageSize,
        });
    }, [eventKinds, search]);
    return useFetchAction(fetchEventsMetaData);
};
